import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'

const SuccessErrorPopup = ({
    show,
    handleClose,
    errorMessage,
    isSuccess
}) => {
    return (
        <>
            <Modal
                isOpen={show}
                toggle={handleClose}
                backdrop='static'
                keyboard={false}
            >
                <ModalHeader toggle={handleClose} className='modal-header_box blueBtn p-3 d-flex justify-content-between modal-header m-0'>
                    {isSuccess ? "Success" : "Error Message"}
                </ModalHeader>

                <ModalBody>
                    <div className='py-1 text-center'>
                        <h3 className='text-warning font_54'>
                            {!isSuccess ? (
                                <i className='fa fa-exclamation-circle'></i>
                            ) : (
                                <i className='fa fa-check-circle text-success' style={{ fontSize: '48px' }}></i>
                            )}
                        </h3>
                        <h4 className='blue_dark_text font_weight_700'>
                            {errorMessage}
                        </h4>
                    </div>
                </ModalBody>

                <div className='text-center p-3'>
                    <button
                        className='btn closeBtn'
                        onClick={handleClose}
                    >
                        OK
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default SuccessErrorPopup
